import React from 'react';
import { Flex } from '@chakra-ui/react';
import { CallToActionButton } from '../ctaButton';
import { AddressPropTypes } from './AddressPropTypes';
import { buttonStyles } from './constant';

export const CTAButtons = ({ ctaButtonConfig }: AddressPropTypes.IButtons) => {
  return (
    <Flex direction={'column'} gap={'16px'}>
      {ctaButtonConfig.map((config, index) => {
        return <CallToActionButton key={index} {...config} otherButtonProps={buttonStyles} />;
      })}
    </Flex>
  );
};
